import styled from 'styled-components'

import { Tokens } from '@/assets/tokens'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${Tokens.ColorTextPrimary}70;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(0.2rem);
  z-index: 1000;
`

export const Modal = styled.div<{ $size?: 'default' | 'large' }>`
  width: ${({ $size }) => ($size === 'large' ? '90vw' : '30rem')};
  max-width: ${({ $size }) => ($size === 'large' ? '100%' : '90vw')};
  height: fit-content;
  max-height: ${({ $size }) => ($size === 'large' ? '90vh' : '80vh')};

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 1.5rem;

  background-color: white;
  border-radius: 1rem;
  padding: 2rem;
`

export const IconContainer = styled.div`
  width: 4rem;
  height: 4rem;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;

  font-size: 2rem;
`

export const Title = styled.div`
  text-align: center;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
  display: flex;
  justify-content: center;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
  }

  /* Style for ReactNode titles (emoji + text) */
  > div {
    font-size: 1.75rem;
    font-weight: 600;

    span {
      font-weight: 600;
      font-size: 1.3rem;
    }
  }
`

export const Content = styled.div<{ $size?: 'default' | 'large' }>`
  font-size: 14px;
  overflow-y: auto;
  max-height: ${({ $size }) => ($size === 'large' ? '60vh' : '40vh')};
`

export const ButtonGroup = styled.div<{ $justified?: boolean }>`
  display: flex;
  justify-content: ${({ $justified }) => ($justified ? 'space-between' : 'center')};
  align-items: center;
  gap: 12px;

  ${({ $justified }) =>
    !$justified &&
    `
    button {
      min-width: 120px;
      background-color: ${Tokens.ColorUIPrimary} !important;

      &:hover {
        background-color: ${Tokens.ColorUIPrimaryDim} !important;
      }

      &[data-variant='secondary'] {
        background-color: ${Tokens.ColorBackground} !important;
        color: ${Tokens.ColorTextPrimary} !important;
        border: 1px solid ${Tokens.ColorBorder} !important;

        &:hover {
          background-color: ${Tokens.ColorHover} !important;
          border-color: ${Tokens.ColorUIPrimary} !important;
        }
      }
    }
  `}
`
